// extracted by mini-css-extract-plugin
export var barsContainer16 = "SortAnimation-module--barsContainer16--9RvQa";
export var barsContainer32 = "SortAnimation-module--barsContainer32--mP5Hu";
export var barsContainer4 = "SortAnimation-module--barsContainer4--49Etq";
export var barsContainer64 = "SortAnimation-module--barsContainer64--FYorn";
export var barsContainer8 = "SortAnimation-module--barsContainer8--l6eea";
export var li = "SortAnimation-module--li--bZDfV";